/**
 * Connects the double result selectors
 * @module app/views/BetDropdownViewAdapter
 */
import _ from 'lodash';
import jQuery from 'jquery';
import SelectOptionsTemplate from './templates/events/selectOptions';

/**
 * An object used to cache the jQuery pointers to select boxes
 *
 * @type {Object}
 *
 * @private
 */
var $selectCache = {};

/**
 * A function to get and set the cache of jquery select boxes
 *
 * @param {String} elementId The id of the select box required
 *
 * @returns {Object} the jquery object from the cache
 *
 * @private
 */
var selectCacheManager = function selectCacheManager(elementId) {

    if (!$selectCache[elementId]) {

        $selectCache[elementId] = jQuery('#' + elementId);
    }

    return $selectCache[elementId];
};

/**
 * Template for the contents of a select box to be rendered
 *
 * @type {Function}
 *
 * @private
 */
var selectOptionsTemplate = _.template(SelectOptionsTemplate);

/**
 * Event handler to update the multi purpose selection button based on the position of the dropdowns
 *
 * @returns {void}
 *
 * @private
 */
var handleDrSelectionChange = function handleDrSelectionChange() {

    var $thisDropdown = selectCacheManager(this.id);

    var outcome =
        $thisDropdown.parents('section.btmarket.dr').find('select.betdropdown').first().val() +
        '/' +
        $thisDropdown.parents('section.btmarket.dr').find('select.betdropdown').last().val();

    var selectButton =
        $thisDropdown.parents('section.btmarket.dr').find('button.betbutton');

    var sourceButton =
        $thisDropdown.parents('div.btmarket__wrapper').find('button[data-name="' + outcome + '"]').last();

    selectButton.replaceWith(sourceButton.clone(true, true));

};

/**
 * Binds the event handller to the change event of the dropdown select elements
 *
 * @param {Object} parentElement A jQuery object representing the portion of the dom that double result select
 * boxes are present in
 *
 * @returns {void}
 *
 * @private
 */
var bindDrEvents = function bindEvents(parentElement) {

    parentElement.on('change.DoubleResultDropdownBindEvents',
        'select.betdropdown',
        handleDrSelectionChange);
};

/**
 * Handles the change events for the correct score picker dropdowns
 *
 * @returns {void}
 *
 * @private
 */
var handleCsSelectionChange = function handleCsSelectionChange() {

    var $thisDropdown = selectCacheManager(this.id);

    setAllowedCsScoresOnSibling(this.id, $thisDropdown);
    setCsDynamicSelection(this.id, $thisDropdown);
};

/**
 * Sets the correct score dynamic selection button to match the values in the dropdown boxes
 *
 * @param {String} elementId The id of the select box which has been changed
 * @param {Object} $thisDropdown The jQuery object representing the current dropdown
 *
 * @returns {void}
 *
 * @private
 */
var setCsDynamicSelection = function setCsDynamicSelection(elementId, $thisDropdown) {

    var score = selectCacheManager(elementId.replace($thisDropdown.attr('data-cs-team'), 'home')).val() +
        '-' +
        selectCacheManager(elementId.replace($thisDropdown.attr('data-cs-team'), 'away')).val();

    var sourceButton =
        $thisDropdown.parents('div.btmarket__wrapper').find('button[data-cs-score="' + score + '"]').last();

    var targetButton = $thisDropdown.parents('section.btmarket.cs').find('button.betbutton').first();

    targetButton.replaceWith(sourceButton.clone(true, true));
};

/**
 * Sets the allowed values on the sibling select box based on the current value in the active select box
 *
 * @param {String} elementId The id of the active select box
 * @param {Object} $thisDropdown The jQuery object representing the current dropdown
 *
 * @returns {void}
 *
 * @private
 */
var setAllowedCsScoresOnSibling = function setAllowedCsScoresOnSibling(elementId, $thisDropdown) {

    var teams = {
        thisTeam: $thisDropdown.attr('data-cs-team'),
        thatTeam: ($thisDropdown.attr('data-cs-team') === 'home') ? 'away' : 'home',
    };

    var $thatDropDown = selectCacheManager(elementId.replace(teams.thisTeam, teams.thatTeam));

    var scores = {
        thisTeam: parseInt($thisDropdown.val(), 10),
        thatTeam: $thatDropDown.val(),
    };

    setCsOutcomeMatrix($thisDropdown);

    $thatDropDown.html(selectOptionsTemplate({
        data: $thisDropdown.outcomeMatrix[scores.thisTeam],
    }));

    $thatDropDown.val(scores.thatTeam);
};

/**
 * Checks whether the correct score allowed outcome matric has been set on an element, sets it if is has not
 *
 * @param {Object} element A jquery pointer to a select box
 *
 * @returns {void}
 *
 * @private
 */
var setCsOutcomeMatrix = function setCsOutcomeMatrix(element) {

    element.outcomeMatrix = element.outcomeMatrix || JSON.parse(element.attr('data-cs-outcome-matrix'));
};

/**
 * Binds the event handlers to the correct score picker dropdowns
 *
 * @param {Object} parentElement A jQuery object representing the element containing the dropdowns
 *
 * @returns {void}
 *
 * @private
 */
var bindCsEvents = function bindCsEvents(parentElement) {

    parentElement.on('change.CorrectScoreDropdownBindEvents',
        'select.betdropdown',
        handleCsSelectionChange);
};

var api = {

    /**
     * Init call to start module
     *
     * @returns {void}
     *
     * @public
     */
    init: function init() {

        $selectCache = {};
        bindDrEvents(jQuery('section.btmarket.dr'));
        bindCsEvents(jQuery('section.btmarket.cs'));
    },
};

export default api;
